import '../../themes/global.scss';

import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomPortal from 'commonComponents/CustomPortal';
import {
  FETCH_ACTION_REQUIRED_JOBS_ACTION,
  FETCH_OPEN_JOBS_ACTION,
  FETCH_SCHEDULED_JOBS_ACTION,
  FETCH_TODAY_JOBS_ACTION,
  GET_JOBS_BY_STATUS_DATE_ACTION,
  cancelJob,
  fetchActionRequiredJobs,
  fetchOpenJobs,
  fetchScheduledJobs,
  fetchTodayJobs,
  hideSuccessJobCancelation,
  reportJobNoShow,
  selectJob
} from '../../actions';
import { createLoadingSelector } from '../../api/selectors';
import BackButton from '../../commonComponents/BackButton';
import CustomSpinner from '../../commonComponents/CustomSpinner';
import { DotsMenu, MenuItem } from '../../commonComponents/DotsMenu';
import arrowRight from '../../images/arrow_right.svg';
import TrashIcon from '../../images/icons/Trash';
import shareIcon from '../../images/share-icon-blue.svg';
import { Colors } from '../../themes/colors';
import InviteFavorites from '../InviteFavorites';
import AnimatedCloseCircle from '../shared/AnimatedCloseCircle';
import ConfirmPopup from '../shared/ConfirmPopup';
import JobTypeEnum from './JobTypeEnum';
import SuccessReportNoShowPopup from './SuccessReportNoShowPopup';
import { TodayJobs } from './TodayJobs';
import { getNumberOfCandidates } from './utils';

const normalText = {
  fontFamily: 'Nunito',
  fontSize: 16,
  color: Colors.neutral_600,
  textTransform: 'capitalize',
  width: '20%',
  margin: 10,
  textAlign: 'center'
};

const titleText = {
  fontFamily: 'Nunito',
  fontWeight: 'bold',
  fontSize: '18px',
  color: Colors.primary_500,
  width: '20%',
  textAlign: 'center'
};

const loadingSelector = createLoadingSelector([
  GET_JOBS_BY_STATUS_DATE_ACTION,
  FETCH_OPEN_JOBS_ACTION,
  FETCH_SCHEDULED_JOBS_ACTION,
  FETCH_ACTION_REQUIRED_JOBS_ACTION,
  FETCH_TODAY_JOBS_ACTION
]);

export default ({ history, match }) => {
  const dispatch = useDispatch();
  const [showReportNoShowPopup, setShowReportNoShowPopup] = useState(false);
  const [showInviteFavoritesPopup, setShowInviteFavoritesPopup] = useState(false);
  const [cancelJobPopup, setCancelJobPopup] = useState({isOpen: false, job: null});
  const jobListScrollRef = useRef(null);
  const jobListPagination = useSelector((state) => state.job.dashboardJobListPagination);
  const isLoading = useSelector((state) => loadingSelector(state));
  const showSuccessReportNoShowPopup = useSelector(
    (state) => state.job.showSuccessReportNoShowPopup
  );
  const showSuccessJobCancelationPopup = useSelector(
    (state) => state.job.showSuccessJobCancelationPopup
  );

  const type = history.location.state ? history.location.state.type : match.params.type;

  let jobList = [];

  switch (type) {
  case JobTypeEnum.active:
    jobList = useSelector((state) => state.job.openJobs);
    break;
  case JobTypeEnum.scheduled:
    jobList = useSelector((state) => state.job.scheduledJobs);
    break;
  case JobTypeEnum.actionRequired:
    jobList = useSelector((state) => state.job.actionRequiredJobs);
    break;
  case JobTypeEnum.today:
    jobList = useSelector((state) => state.job.todayJobs);
    break;
  default:
    jobList = [];
  }

  const fetchJobList = (data) => {
    switch (type) {
    case JobTypeEnum.active:
      dispatch(fetchOpenJobs(data));
      break;
    case JobTypeEnum.scheduled:
      dispatch(fetchScheduledJobs(data));
      break;
    case JobTypeEnum.actionRequired:
      dispatch(fetchActionRequiredJobs(data));
      break;
    case JobTypeEnum.today:
      dispatch(fetchTodayJobs(data));
      break;
    default:
      break;
    }
  };

  useEffect(() => {
    fetchJobList({ page: 1 });
  }, [type]);

  const handleScrollJobList = () => {
    const jobListRef = jobListScrollRef?.current;
    const userScrollHeight = jobListRef?.scrollHeight - jobListRef?.scrollTop - 20;
    const clientHeight = jobListRef?.clientHeight;

    if (
      userScrollHeight <= clientHeight
      && !jobListPagination.isActiveRequest
      && !jobListPagination.isFinal
    ) {
      fetchJobList({
        page: jobListPagination?.page + 1
      });
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScrollJobList);
    return () => window.removeEventListener('scroll', handleScrollJobList);
  }, [jobListPagination]);

  const btnSelectedJobs = (item) => {
    history.push(`/dashboard/job/${item.id}`, {
      jobId: item.id
    });
  };

  const getStatusText = (item) => {
    const lowestRate = item.status === 'counter' ? item.best_counter?.rate : item.rate;
    if (item.status === 'pending') return 'ACTION REQUIRED';
    if (item.status === 'counter') return `COUNTER - $${lowestRate.toFixed(2)}`;
    if (item.status === 'filled') return 'Scheduled';
  };

  if (type === 'today') {
    return <TodayJobs />;
  }

  return (
    <div className="component_container">
      <div
        className="floating_container"
        style={{
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          padding: 40,
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            marginBottom: 20,
          }}
        >
          <BackButton />
          <h1
            className="global_font f-dark"
            style={{
              marginLeft: 30,
              marginBottom: 45,
              textAlign: 'center',
              textTransform: 'capitalize',
            }}
          >
            {type === JobTypeEnum.actionRequired ? 'Action Needed Offers' : `${type} Jobs`}
          </h1>
          <div
            style={{
              flex: 1,
              margin: 10,
              display: 'flex',
            }}
          >
            <span style={titleText}>Office</span>

            {(type === JobTypeEnum.today || type === JobTypeEnum.scheduled) && (
              <span style={titleText}>Professional</span>
            )}

            <span style={titleText}>Shift Details</span>

            <span style={titleText}>Profession</span>

            {type === JobTypeEnum.actionRequired ? (
              <span style={titleText}>Candidates</span>
            ) : (
              <div />
            )}

            {type !== JobTypeEnum.actionRequired && type !== JobTypeEnum.today && (
              <span style={titleText}>Rate</span>
            )}

            {type !== JobTypeEnum.actionRequired && type !== JobTypeEnum.today && (
              <span style={titleText}>Status</span>
            )}

            {type === JobTypeEnum.today && <span style={titleText}>No-Show</span>}

            {type === JobTypeEnum.actionRequired && (
              <span style={titleText}>
                <div style={{ padding: '0px 40px' }}>Send to Favorites</div>
              </span>
            )}

            {type === JobTypeEnum.actionRequired && (
              <span style={titleText}>
                <div style={{ padding: '0px 40px' }}>More</div>
              </span>
            )}

            <span style={{ margin: '0px 25px' }} />
          </div>
          <div style={{ height: 1, backgroundColor: '#F6F6F6' }} />
          <div
            ref={jobListScrollRef}
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div>
              {jobList.map((job) => {
                const reportAllowed =
                  moment().diff(moment(`${job.local_start_time}`, 'hh:mm A'), 'minutes') >= 30;

                return (
                  <div
                    key={job.id}
                    style={{
                      flex: 1,
                      margin: 10,
                      display: 'flex',
                      cursor: 'pointer',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderBottom: `1px solid ${Colors.neutral_100}`,
                      paddingBottom: 8,
                    }}
                    onClick={() => btnSelectedJobs(job)}
                  >
                    <span style={normalText}>{job.offer_owner.office_name}</span>

                    {type === JobTypeEnum.today && (
                      <span style={normalText}>{`${job.professional?.full_name}`}</span>
                    )}

                    {type === JobTypeEnum.scheduled ? (
                      <span
                        style={{
                          fontFamily: 'Nunito',
                          fontSize: 16,
                          color: Colors.neutral_600,
                          textTransform: 'capitalize',
                          width: '20%',
                          margin: 10,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {`${job.offer_final_reciever?.first_name} ${job.offer_final_reciever?.last_name}`}
                      </span>
                    ) : (
                      <div />
                    )}

                    <span
                      style={{
                        fontFamily: 'Nunito',
                        fontSize: 16,
                        color: Colors.neutral_600,
                        width: '20%',
                        margin: 10,
                        textAlign: 'center',
                        textTransform: 'uppercase',
                      }}
                    >
                      <p
                        style={{
                          textTransform: 'capitalize',
                          fontWeight: 'bold',
                          margin: 0,
                        }}
                      >
                        {job.local_date}
                      </p>

                      <p style={{ textTransform: 'lowercase', margin: 0 }}>
                        {`${job.local_start_time} - ${job.local_end_time}`}
                      </p>
                    </span>

                    <span style={normalText}>
                      <strong>{job.professionName}</strong>
                      <br />
                      {job?.specialty?.split('_')?.[1] || 'General'}
                    </span>

                    {type !== JobTypeEnum.today && type !== JobTypeEnum.actionRequired && (
                      <span
                        style={{
                          fontFamily: 'Nunito',
                          fontSize: 16,
                          color: Colors.neutral_600,
                          textTransform: 'capitalize',
                          width: '20%',
                          margin: 10,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {' '}
                        {`$${job.rate.toFixed(2)}`}
                      </span>
                    )}

                    {type === JobTypeEnum.actionRequired ? (
                      <span
                        style={{
                          fontFamily: 'Nunito',
                          fontSize: 16,
                          color: Colors.neutral_600,
                          textTransform: 'capitalize',
                          width: '20%',
                          margin: 10,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                          }}
                        >
                          {getNumberOfCandidates(job?.multipleCounters)}
                        </div>
                      </span>
                    ) : (
                      <div />
                    )}

                    {type !== JobTypeEnum.actionRequired && type !== JobTypeEnum.today && (
                      <span
                        style={{
                          fontFamily: 'Nunito',
                          fontSize: 16,
                          color:
                            job.status === 'pending' || job.status === 'counter'
                              ? Colors.error_500
                              : Colors.success_700,
                          textTransform: 'capitalize',
                          width: '20%',
                          margin: 10,
                          textAlign: 'center',
                          fontWeight: 'bold',
                        }}
                      >
                        {job.status === 'open' ? job.status : getStatusText(job)}
                      </span>
                    )}

                    {type === JobTypeEnum.today && (
                      <div
                        style={{
                          width: '20%',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        {job.reportNoShow ? (
                          <p
                            style={{
                              fontFamily: 'Nunito',
                              fontSize: 16,
                              fontWeight: 'bold',
                              color: Colors.error_700,
                            }}
                          >
                            Reported
                          </p>
                        ) : (
                          <button
                            type="button"
                            disabled={!reportAllowed}
                            onClick={(event) => {
                              event.stopPropagation();
                              setShowReportNoShowPopup({
                                id: job.id,
                                name: `${job.offer_final_reciever?.first_name} ${job.offer_final_reciever?.last_name}`,
                                jobDate: job.job_datetime,
                              });
                            }}
                            style={{
                              fontFamily: 'Nunito',
                              fontSize: 16,
                              color: reportAllowed ? Colors.error_700 : Colors.error_300,
                              backgroundColor: reportAllowed ? Colors.error_300 : Colors.error_50,
                              cursor: reportAllowed ? 'pointer' : 'default',
                              textTransform: 'capitalize',
                              borderRadius: 100,
                              fontWeight: 'bold',
                              textAlign: 'center',
                            }}
                          >
                            Report
                          </button>
                        )}
                      </div>
                    )}

                    {type === JobTypeEnum.actionRequired && (
                      <span
                        style={{
                          fontFamily: 'Nunito',
                          fontSize: 16,
                          color: Colors.neutral_600,
                          textTransform: 'capitalize',
                          width: '20%',
                          margin: 10,
                          fontWeight: 'bold',
                          textAlign: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <button
                          type="button"
                          style={{ all: 'unset', display: 'flex' }}
                          onClick={(event) => {
                            event.stopPropagation();

                            dispatch(selectJob(job));

                            setShowInviteFavoritesPopup(true);
                          }}
                        >
                          <img src={shareIcon} alt="share_icon" />
                        </button>
                      </span>
                    )}

                    {type === JobTypeEnum.actionRequired && (
                      <div
                        style={{
                          width: '20%',
                          margin: 10,
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <DotsMenu>
                          <MenuItem
                            Icon={() => <TrashIcon color={Colors.neutral_600} />}
                            text="Cancel Shift"
                            onClick={() => setCancelJobPopup({ isOpen: true, job })}
                          />
                        </DotsMenu>
                      </div>
                    )}

                    <span style={{ margin: '0px 25px' }}>
                      <img
                        src={arrowRight}
                        style={{ width: 10, objectFit: 'cover' }}
                        alt="arrow_right"
                      />
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
          {jobList.length === 0 && !isLoading && (
            <div>
              <p className="font_bold" style={{ textAlign: 'center' }}>
                {type === 'today'
                  ? 'There are no scheduled shifts for today.'
                  : `There are no ${type === 'actionRequired' ? 'action required' : type} jobs.`}
              </p>
            </div>
          )}
          {isLoading && <CustomSpinner isLoading={isLoading} />}
        </div>
      </div>

      {showReportNoShowPopup && (
        <ConfirmPopup
          title="Report a No-Show"
          description={
            <>
              Are you sure you would like to report <strong>{showReportNoShowPopup.name}</strong> as
              a No-Show?
            </>
          }
          leftButtonText="Cancel"
          leftButtonAction={() => setShowReportNoShowPopup(false)}
          rightButtonText="Confirm"
          rightButtonAction={() => {
            dispatch(reportJobNoShow(showReportNoShowPopup.id));
            setShowReportNoShowPopup(false);
          }}
        />
      )}

      {showSuccessReportNoShowPopup && <SuccessReportNoShowPopup />}

      {showInviteFavoritesPopup && (
        <InviteFavorites setShowInviteFavoritesPopup={setShowInviteFavoritesPopup} />
      )}

      {cancelJobPopup.isOpen && (
        <ConfirmPopup
          Icon={() => <AnimatedCloseCircle />}
          title="Are you sure you want to cancel?"
          titleStyle={{ marginTop: 20 }}
          description={
            <>
              Are you sure you would like to cancel the shift for
              <br />
              <b>{cancelJobPopup.job?.local_date}</b>
            </>
          }
          descriptionStyle={{ marginBottom: 50 }}
          leftButtonText="Go Back"
          leftButtonAction={() => setCancelJobPopup({ isOpen: false, job: null })}
          rightButtonText="Cancel Shift"
          rightButtonAction={() => {
            dispatch(cancelJob({ jobId: cancelJobPopup.job?.id }));
            setCancelJobPopup({ isOpen: false, job: null });
          }}
        />
      )}

      {
        showSuccessJobCancelationPopup && 
        <CustomPortal
          isSuccess
          redirect={false}
          title="Cancellation Confirmed"
          text="This shift has been successfully cancelled."
          submitPressed={() => {
            dispatch(fetchActionRequiredJobs({ page: 1 }))
            dispatch(hideSuccessJobCancelation());
          }}
        />
      }
    </div>
  );
};
